'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itFooterManager", function (itFooterAccumulator) {
  return function (tableCtrl) {
    var manager = this,
      tableScope = tableCtrl.getScope(),
      linkers = tableCtrl.linkers,
      context = tableCtrl.getContext(),
      ui = tableCtrl.ui,
      footerRootScope = null;

    /**
     * Compute the footer values and inject them in the table scope's `footerValues` properties.
     *
     * `footerValues` is a Map<column.id, value>
     */
    manager.computeFooterValues = function () {
      context.footerValues = {};
      if (tableCtrl.getConfig().footer === false) {
        return;
      }
      var dataSource = tableCtrl.getDataSource();
      var footerValues = {};
      context.columns.filter(function (column) {
        var colDef = column.column;
        return (colDef.dataType || colDef.footerReducer) && column.column.footer !== false;
      }).forEach(function (column) {
        var footerValue = itFooterAccumulator.accumulate(dataSource, column.column);
        footerValues[column.id] = footerValue;
      });
      context.footerValues = footerValues;
    };

    /**
     * Return true if the table config define a static footer, false otherwise.
     */
    manager.hasStaticFooter = function (config) {
      return config.footer === 'static' || config.footer === true;
    };

    /**
     * Return true if the table config define an inline footer, false otherwise.
     */
    manager.hasInlineFooter = function (config) {
      return config.footer === 'inline';
    };

    /**
     * Refresh the static footer, adding, removing or updating it depending on the current config.
     */
    manager.refreshStaticFooter = function () {
      if (footerRootScope != null) {
        footerRootScope.$destroy();
        footerRootScope = null;
        ui.footerTable.find('tfoot').empty();
      }
      if (manager.hasStaticFooter(tableCtrl.getConfig())) {
        ui.footerDiv.show();
        footerRootScope = tableScope.$new();
        createFooterRow();
      } else {
        ui.footerDiv.hide();
      }
    };
    var createFooterRow = function createFooterRow() {
      ui.contentFoot.empty();
      var footerRowLinker = linkers.footerRow;
      var footerRow = null;
      footerRowLinker(tableScope, function (_footerRow) {
        footerRow = _footerRow;
        footerRow.appendTo(ui.footerTable.find('tfoot'));
      });
      footerRowLinker(tableScope, function (_footerRow) {
        footerRow = _footerRow;
        footerRow.appendTo(ui.contentFoot);
      });
      ui.contentFoot.hide();
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itFooterManager.js
// module id = 2795
// module chunks = 13